// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ljnG","footer":"ModalCreateQualiphyProcedure_footer__28G_3","additionData":"ModalCreateQualiphyProcedure_additionData__385Z1"};